import { RegistrationItem, RegistrationItemVariation } from "../models/registrations/registrations";
import {itemQuantityReserved} from "../models/item/item";



export const getItemsForEvent = async (eventId: number): Promise<RegistrationItem[]> =>
{
    const requestOptions = 
    {
        method: 'GET',
        headers: { 'Authorization': 'Basic YnV6ejpmcjBudGllcg==' }
    }

    const url = new URL(process.env.REACT_APP_REFLEBULA + '/a1/tga/items/forEvent');
    url.searchParams.append('event_id', eventId.toString());

    return fetch(url, requestOptions).then((res) => res.json()).then((body) =>
    {
        return body.map((element: any) => 
        {
            const unitPrice = element.unit_price === null ? 0 : Number(element.unit_price);
            return({
                    id: element.id,
                    displayName: element.name,
                    unitPrice: unitPrice,
                    remainingInventory: element.inventory,
                    displayOrd: element.display_ordinal,
                    itemType: element.type
            })
        })
    });

}

export const getItemVariationsForItem = async (itemId: number): Promise<RegistrationItemVariation[]> =>
{
    const requestOptions = 
    {
        method: 'GET',
        headers: { 'Authorization': 'Basic YnV6ejpmcjBudGllcg==' }
    }

    const url = new URL(process.env.REACT_APP_REFLEBULA + '/a1/tga/items/forItem');
    url.searchParams.append('item_id', itemId.toString());

    return fetch(url, requestOptions).then((res) => res.json()).then((body) =>
    {
        return body.map((element: any) => 
        {
            const unitPrice = element.unit_price === null ? 0 : Number(element.unit_price);
            return({
                    id: element.id,
                    itemId: element.item_id,
                    displayName: element.display_name,
                    unitPrice: unitPrice,
                    displayOrd: element.display_ordinal,
                    itemType: element.type
            })
        })
    });

}

/*
    Types and functions to handle sending an item reservation request to the backend
    (TODO: We can probably remove user_id from this)
    For cart_id:
    When making the first reservation request for a cart, leave this undefined. The backend should return a cart id to be used.
    For future reservation requests (additional items in the cart, or changing quantity of items,) use the cart id value given.
    When processing a payment, provide the cart id as well (which will remove the items from the reservation table.)
    (The reserveItemsFromInventory and the processPayment functions should take care of all this for you.)

    In the event the user doesn't go through with a purchase, there is nothing that needs to be sent to the cart_id.
    All that needs to be done is to forget the cart_id.
    Eventually, the clean up cronjob will unreserve the items.
*/
interface itemQuantityResReq {
    item_dbid: number;
    user_id: number; 
    quantity: number;
    cart_id?: string;
}

export const reserveItemFromInventory = async (itemId: number, userId: number, quant:number): Promise<itemQuantityReserved> =>
{
    const cartId = getCartId();

    const objItemRes : itemQuantityResReq = {
        item_dbid : itemId,
        user_id : userId,
        quantity: quant,
        cart_id: cartId
    }

    const requestOptions = 
    {
        method: 'POST',
        headers: { 'Authorization': 'Basic YnV6ejpmcjBudGllcg==', 'Content-Type': 'application/json' },
        body: JSON.stringify(objItemRes)
    }

    //get the userid
    // Response is : "{'reserved_quantity' : 4}"
    console.log(requestOptions.body);
    const url = new URL(process.env.REACT_APP_REFLEBULA + '/a1/tga/order/item/quantity');
    return fetch(url, requestOptions).then((res) => res.json()).then((body) =>
    {
        console.log(body);
        const respCartId = body.cart_id;
        if(respCartId && respCartId !== cartId)
        {
            updateCartId(respCartId);
        }
        return body;
    });
        

}

const updateCartId = (cartId: string) =>
{
    sessionStorage.setItem('cartReservationId', JSON.stringify(cartId));
}

export const deleteCartId = () =>
{
    sessionStorage.removeItem('cartReservationId');
}

export const getCartId = () : string | undefined =>
{
    return sessionStorage.getItem('cartReservationId') ?? undefined;
}
